import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ExamFilter } from '../../../../shared/ExamModuleTypes';
import { Button, Form, Typography } from 'antd';
import { SelectedDropdownValue } from '../../../../shared/VolunteerApplicationServiceTypes';
import RegionsDropdown from '../../../../components/RegionsDropdown';
import { useAuth } from '../../../../hooks/useAuth';

interface FilterProps {
	value: ExamFilter;
	onFilterChange: (value: ExamFilter) => void;
	examIdInSnap: number;
}

interface ExamResultFilterFormType {
	regions?: SelectedDropdownValue;
}

const { Text } = Typography;

export const FilterTables = ({
	value,
	onFilterChange,
	examIdInSnap,
}: FilterProps) => {
	const { t } = useTranslation();
	const { srcmId } = useAuth();
	const [form] = Form.useForm<ExamResultFilterFormType>();
	const values = Form.useWatch<ExamResultFilterFormType>([], form);

	const handleFilterClick = useCallback(() => {
		const filterValues: ExamFilter = {
			...values,
			regionIds: [values?.regions?.value] as Array<number>,
		};
		const examFilters = { ...value, ...filterValues };
		onFilterChange(examFilters);
	}, [onFilterChange, value, values]);

	const handleResetForm = useCallback(() => {
		form.resetFields();
		form.setFieldsValue({
			regions: undefined,
		});
		const filterValues: ExamFilter = { examId: examIdInSnap };
		onFilterChange(filterValues);
	}, [examIdInSnap, form, onFilterChange]);

	const handleRegionChange = useCallback(() => {}, []);

	return (
		<div className="flex flex-col">
			<Form
				name="examResultFilterForm"
				layout="horizontal"
				size="middle"
				labelCol={{ span: 24 }}
				wrapperCol={{ span: 24 }}
				autoComplete="off"
				initialValues={value}
				form={form}
			>
				<div className="flex flex-col md:mb-0">
					<div className="flex flex-col gap-4 md:flex-row">
						<div className="flex flex-col md:mb-0 min-w-[170px]">
							<Text className="pl-1">{t('regions')}</Text>
							<Form.Item className="!mb-2" name={'regions'}>
								<RegionsDropdown
									functionarySrcmId={srcmId}
									examIdInSnap={examIdInSnap}
									onChange={handleRegionChange}
									getExamRegions={true}
								/>
							</Form.Item>
						</div>
					</div>
				</div>
			</Form>
			<div className="flex flex-row gap-2 md:mb-0 mt-2">
				<div className="self-start">
					<Button
						className="bg-nav-blue hover:!bg-hover-nav-blue text-white"
						type="primary"
						disabled={values?.regions ? false : true}
						onClick={handleFilterClick}
					>
						{t('filter')}
					</Button>
				</div>
				<div className="self-start">
					<Button type="default" onClick={handleResetForm}>
						{t('clear')}
					</Button>
				</div>
			</div>
		</div>
	);
};
